import React from "react";
import Logo from "../Logo/Logo";
import s from './Header.module.scss'
import { NavLink } from "react-router-dom";

const Header = ({ isAuth, login, getLogout }) => {
  return (
    <header className={s.header}>
      <Logo />
      <div className={s.loginBlock}>
        {isAuth
          ? <><NavLink to='/profile'>{login}</NavLink>&nbsp;&nbsp;
            <button type='button' onClick={getLogout}>log out</button></>
          : <NavLink to='/login'>login</NavLink>}
      </div>
    </header>
  );
}

export default Header;